import React from "react";
import classnames from "classnames";

export default function LcField(props) {
  return (
    <div className="lc-field">
      <label
        className={classnames(
          "input__label",
          { error: props.errorMessage },
          props.classNames
        )}
        htmlFor={props.name}
      >
        {props.text}
      </label>
      {props.children}
      {props.errorMessage && (
        <div className="input__error-message">{props.errorMessage}</div>
      )}
    </div>
  );
}
